export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xHIzIXKMnyrYk.c6f3189b.woff2";